export default {
    ENFERMAGEM: 1,
    CONSULTA_MEDICA: 2,
    EXAME_RAIO_X: 3,
    NAO_SE_APLICA: 4,
}